import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PostHooks from "../../../Hooks/PostHooks";
import UpdateHooks from "../../../Hooks/UpdateHooks";

const SuperAdminHomeState = () => {

    const [formData, setFormData] = useState({
        city: 0,
        awards: 0
    });

    //   load data
    useEffect(() => {
        fetch(`https://servercareseebd.careseebd.com/api/v1/homeState/getHomeState`)
            .then((res) => res.json())
            .then((data) => {
                if (data?.data.length) {
                    setFormData(data?.data[0]);
                }
            });
    }, []);

    // update and post data
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (formData?._id) {
                await UpdateHooks(
                    `https://servercareseebd.careseebd.com/api/v1/homeState/updateHomeState/${formData?._id}`,
                    { ...formData }
                );
                toast?.success(`HomeState section Updated !`);
            } else {
                await PostHooks(
                    `https://servercareseebd.careseebd.com/api/v1/homeState/addHomeState`,
                    { ...formData },
                    `homeState data posted`
                );
            }
        } catch (error) {
            toast?.success(error);
        }
    };

    // set data in state
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    return (
        <div className="bg-white">
            <div className="w-fit  text-xl font-semibold mb-5">
                <h1>Update Home State Section</h1>
                <div className="h-1 mt-1 bg-secondary w-[40%]"></div>
            </div>
            <form
                onSubmit={handleSubmit}
                className="bg-gray-50 p-6 rounded shadow-md w-full mx-auto"
            >


                <div className="mb-4">
                    <label
                        className="block mb-2 text-sm font-medium text-gray-600"
                        htmlFor="name"
                    >
                        City
                    </label>
                    <input
                        type="number"
                        name="city"
                        required
                        onChange={handleChange}
                        value={formData.city}
                        className="w-full px-3 py-2 border rounded-md focus:outline-none"
                    />
                </div>
                <div className="mb-4">
                    <label className="block mb-2 text-sm font-medium text-gray-600">
                        Awards
                    </label>
                    <input
                        name="awards"
                        required
                        onChange={handleChange}
                        value={formData.awards}
                        className="w-full px-3 py-2 border rounded-md focus:outline-none"
                    ></input>
                </div>
                <div>
                    <button
                        type="submit"
                        className="bg-secondary text-white px-4 py-2 rounded hover:bg-secondary/90 hover:scale-105 duration-300"
                    >
                        Update Home State !
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SuperAdminHomeState;
